// extracted by mini-css-extract-plugin
export default {"skeleton":"SkeletonLoader_skeleton__V+i72","animate":"SkeletonLoader_animate__WwmTz","pulse":"SkeletonLoader_pulse__9K8GI"};